module.exports = __webpack_public_path__ + "media/images/partners/onep-3c07282619d9e5f2164c00b80bb46494.png";